import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable()
export class XClientInterceptorInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    let xClientKey = environment.xClientKey;

    let altRequest = request;
    //  get XhHeaders
    if (xClientKey) {
      altRequest = request.clone({
        setHeaders: {
          "x-client-key": environment.xClientKey,
        },
      });
    }
    return next.handle(altRequest);
  }
}
